import axios from "axios";
import { UNAUTHORIZED } from "../constants";
import { RefreshTokenSuccessParams } from "../login/types";
import {
  isRetryRequired,
  loadState,
  saveState,
  setDirty
} from "../route/LocalStorage";
import { APIError, getBaseApiAuthUrl } from "./api";

const instance = axios.create();

instance.interceptors.response.use(
  async response => {
    if (response.status === 401 && response.config) {
      return await digestUnauthorized(response);
    }

    if (response.status === 400) {
      return response.data.message;
    }

    const possibleReturnCodes = [431, 432, 433, 438, 439, 440, 441];
    if (
      response.data &&
      possibleReturnCodes.includes(response.data.returnCode)
    ) {
      return response.data.message;
    }

    return response;
  },
  async error => {
    if (error.response && error.response.status === 401 && error.config) {
      return await digestUnauthorized(error);
    }

    throw new APIError(error.message);
  }
);

instance.defaults.validateStatus = (status: number) => {
  if (status === 401 || status === 456 || status === 400) {
    return true;
  }

  return status >= 200 && status < 300;
};

const digestUnauthorized = async response => {
  const url = response.config.url;

  if (url && isRetryRequired()) {
    const state = loadState();
    if (!state) {
      return response;
    }

    const credentials = state.user.user.credentials;
    const headers: any = {};

    headers["Content-Type"] = "application/json";
    const { data }: { data: RefreshTokenSuccessParams } = await axios.post(
      `${getBaseApiAuthUrl()}/refreshAccessToken`,
      { refreshToken: credentials.refreshToken },
      { headers }
    );

    if (!data) {
      throw new APIError(UNAUTHORIZED);
    }

    const { refreshToken, accessToken, issuedAt, expiresIn } = data;
    credentials.refreshToken = refreshToken;
    credentials.accessToken = accessToken;
    credentials.issuedAt = issuedAt;
    credentials.expiresIn = expiresIn;

    saveState(state);
    setDirty(accessToken);

    const origReq = response.config;
    origReq.headers.accessToken = accessToken;
    return axios(origReq).catch(() => {
      throw new APIError(UNAUTHORIZED);
    });
  } else {
    throw new APIError(UNAUTHORIZED);
  }
};

export default instance;



// WEBPACK FOOTER //
// ./src/api/customAxios.ts